import { createContext, RefObject } from "react";

import { NavigationGroup, NavigationItem } from "../types";

export interface NavigatorContextValue {
  // Search
  inputValue: string;
  setInputValue: (value: string) => void;

  // Options
  options: NavigationItem[];
  selectedOption: NavigationItem | null;

  // Loading
  isLoading: boolean;
  loadingGroup?: NavigationGroup;

  // Group pagination
  showLoadMore: (groupKey: NavigationGroup) => boolean;
  onLoadMore: (group: NavigationGroup) => void;

  // Message shown in place of options when there are none — e.g. when the demo
  // URL isn't a Shopify storefront. Undefined falls back to the default text.
  noOptionsText?: string;

  // Refs
  listboxRef: RefObject<HTMLUListElement | null>;
}

export const NavigatorContext = createContext<NavigatorContextValue | null>(
  null
);
